/**
 * useChangelog — busca o CHANGELOG.md cru (GET /api/v1/changelog) e parseia
 * em runtime para ChangelogVersion[] (paridade com o Hub).
 *
 * Fonte única de verdade: CHANGELOG.md na raiz do repo, atualizado a cada
 * release. Substitui os antigos arquivos estáticos `data/changelog/*.ts`.
 */
import { useQuery } from '@tanstack/react-query';
import apiClient from '@/services/apiClient';
import { parseChangelog } from '@/data/changelog/parser';
import type { ChangelogVersion } from '@/data/changelog/types';

async function fetchChangelog(): Promise<ChangelogVersion[]> {
  const resp = await apiClient.get<string>('/changelog', {
    responseType: 'text',
    transformResponse: [(d) => d], // não tentar JSON.parse no markdown
  });
  return parseChangelog(resp.data);
}

export function useChangelog() {
  const query = useQuery({
    queryKey: ['changelog'],
    queryFn: fetchChangelog,
    staleTime: 1000 * 60 * 60, // 1h — changelog muda só em release
    gcTime: 1000 * 60 * 60 * 4,
  });

  return {
    changelog: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}

export default useChangelog;
